export default "__VITE_ASSET__3pJLn3Bv__"